














































    
import {Vue, Component, Mixins} from 'vue-property-decorator';
import { Address, AddressCreate } from '../../services/accounting.service';
import { FormMixin } from './../../mixins/FormMixin'

@Component({})
export default class AddressForm extends Mixins<FormMixin<AddressCreate, Address>>(FormMixin) {

    empty: AddressCreate = {
        streetAddress: '',
        city: '',
        state: '',
        zipCode: '',
        unitType: '',
        unitNumber: '',
    }

    objToDto = (obj: Address) => {
        return obj;
    }

    idFn = (obj: Address) => {
        return obj.id;
    }
}

